module.exports = __webpack_public_path__ + "static/media/eye.c48f7bdf.svg";